'use client';

import clsx from 'clsx';
import { FC } from 'react';

import { RecaptchaNotice } from '../RecaptchaNotice/RecaptchaNotice';
import { FormGenericError } from '../forms/FormGenericError/FormGenericError';
import { FormWithAction } from '../forms/FormWithAction/FormWithAction';
import { InputEmailForm } from '../forms/Input/InputEmailForm';
import { InputForm } from '../forms/Input/InputForm';
import { InputMaskedForm } from '../forms/Input/InputMaskedForm';
import { subscribeFormStartAction } from './SubscribeFormStart.action';
import { SubscribeFormSubmitButton } from './SubscribeFormSubmitButton';

type Props = {
  onSuccess: (email: string) => void;
};

const formRowClass = clsx('grid grid-cols-1 md:grid-cols-2 md:gap-4');

export const SubscribeFormStart: FC<Props> = ({ onSuccess }) => {
  return (
    <FormWithAction
      action={subscribeFormStartAction}
      withRecaptcha="subscribe_form_submit"
      onSuccess={(success) => onSuccess(success.message)}
      renderContent={(state) => (
        <>
          <div className={formRowClass}>
            <InputForm
              type="text"
              name="first_name"
              label="First name"
              labelOutside
              formState={state}
              data-testid="first-name"
            />
            <InputForm
              type="text"
              name="last_name"
              label="Last name (optional)"
              labelOutside
              formState={state}
              data-testid="last-name"
            />
          </div>
          <div className={formRowClass}>
            <InputEmailForm
              name="email"
              label="Email address"
              labelOutside
              showClientError
              formState={state}
              data-testid="email"
            />
            <InputMaskedForm
              type="text"
              name="postcode"
              label="Postcode (optional)"
              inputMode="numeric"
              labelOutside
              mask="0000"
              formState={state}
              data-testid="postcode"
            />
          </div>
          <FormGenericError formState={state} />

          {/* Legals */}
          <div className="mb-6 flex flex-col gap-1">
            <div className="c-fs-caption text-tex-def-tie3">
              View our{' '}
              <a href="/privacy-collection-notice" target="_blank">
                Privacy Collection Notice
              </a>{' '}
              to understand how we use your personal information.
            </div>
            <RecaptchaNotice />
          </div>

          <SubscribeFormSubmitButton>Subscribe</SubscribeFormSubmitButton>
        </>
      )}
    />
  );
};
